import Colors from 'bit/mobiauto.web-ui-components.components.colors/colors';
import styled from 'styled-components';

const drawerWidth = 270;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  background: #00000040;
  height: 100%;
`;

export const styles = theme => ({
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
    left: '10px',
    zIndex: 50,
    color: '#fff',
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: 0,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    zIndex: 1000,
  },
  drawerOpen: {
    backgroundColor: theme.palette.secondary.main || Colors.gray.dark,
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflow: 'initial',
  },
  drawerClose: {
    backgroundColor: theme.palette.secondary.main || Colors.gray.dark,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: '70px',
    // [theme.breakpoints.up('sm')]: {
    //   width: theme.spacing(9) + 1,
    // },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  closeMenuBtn: {
    position: 'absolute',
    right: '6px',
  },
  drawerBody: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100vh',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
});
